var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/path.js
// module id = 419
// module chunks = 0